import React from 'react';
import './App.css';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import SelectBranch from './Components/Notes/SelectBranch';
import Cs from './Components/Notes/Cs';
import Ai from './Components/Notes/Ai';
import Me from './Components/Notes/Me';
import Ce from './Components/Notes/Ce';
import Ee from './Components/Notes/Ee';
import Ec from './Components/Notes/Ec';
import It from './Components/Notes/It';
import Others from './Components/Notes/Others';
import SelectBranchP from './Components/Paper/SelectBranchP';
import Pcs from './Components/Paper/Pcs';
import Pai from './Components/Paper/Pai';
import Pme from './Components/Paper/Pme';
import Pce from './Components/Paper/Pce';
import Pee from './Components/Paper/Pee';
import Pec from './Components/Paper/Pec'; 
import Pit from './Components/Paper/Pit';
import Pothers from './Components/Paper/Pothers';
import SelectBranchB from './Components/Books/SelectBranchB';
import Bcs from './Components/Books/Bcs';
import Bai from './Components/Books/Bai';
import Bme from './Components/Books/Bme';
import Bce from './Components/Books/Bce';
import Bee from './Components/Books/Bee';
import Bec from './Components/Books/Bec'; 
import Bit from './Components/Books/Bit';
import Bothers from './Components/Books/Bothers';
import TopContribuorsV from './Components/ImportantView/TopContribuorsV';
import OnlineToolV from './Components/ImportantView/OnlineToolV';
import SoftwareDownloadV from './Components/ImportantView/SoftwareDownloadV';
import YoutubeUrl from './Components/ImportantView/YoutubeUrl';
import CollegeReviewV from './Components/ImportantView/CollegeReviewV';
import WebsiteUrlV from './Components/ImportantView/WebsiteUrlV';
import Contact from './Components/Contact';
import StudyMaterialsUpload from './Components/StudyMaterialsUpload';
import CollegeReviewF from './Components/UserForm/CollegeReviewF';
import WebsiteUrlF from './Components/UserForm/WebsiteUrlF';
import YoutubeUrlF from './Components/UserForm/YoutubeUrlF';
import OnlineToolF from './Components/UserForm/OnlineToolF';
import SoftwareDownloadF from './Components/UserForm/SoftwareDownloadF';
import About from './Components/About';
import Year4 from './Components/Notes/cs/Year4';
import Year2 from './Components/Notes/cs/Year2';
import Year3 from './Components/Notes/cs/Year3';
import PYear2 from './Components/Paper/CS/PYear2';
import Projects from './Components/Projects';
import Advertisement from './Components/Advertisement';
import Careers from './Components/Careers';
import Job1 from './Components/Job1';
import Job2 from './Components/Job2';
import Job3 from './Components/Job3';
import Terms from './Components/Terms';
import GeneralQuestions from './Components/GeneralQuestions';

export default function App() {
  return (
    <div className="App">
      <Router>
        <Navbar/>
            <Routes>
                <Route path='/' exact element= {<Home/>} />
                <Route path='/Contact' exact element= {<Contact/>} />
                <Route path='/About' exact element = {<About/>} />
                <Route path='/Terms' exact element = {<Terms/>} />
                <Route path='/GeneralQuestions' exact element = {<GeneralQuestions/>} />
                
                <Route path='/Careers' exact element = {<Careers/>} />
                <Route path='/Job1' exact element = {<Job1/>} />

                <Route path='/Job2' exact element = {<Job2/>} />
                <Route path='/Job3' exact element = {<Job3/>} />

                <Route path='/Projects' exact element = {<Projects/>}/>
                <Route path='/StudyMaterialsUpload' exact element= {<StudyMaterialsUpload/>} />
                <Route path='/CollegeReviewF' exact element= {<CollegeReviewF/>} />
                <Route path='/WebsiteUrlF' exact element= {<WebsiteUrlF/>} />
                <Route path='/YoutubeUrlF' exact element= {<YoutubeUrlF/>} />
                <Route path='/OnlineToolF' exact element= {<OnlineToolF/>} /> 
                <Route path='/SoftwareDownloadF' exact element= {<SoftwareDownloadF/>} /> 
                <Route path='/SelectBranch' exact element= {<SelectBranch/>} /> 
                <Route path='/Cs' exact element= {<Cs/>} />
                <Route path='/Advertisement' exact element={<Advertisement/>}/>
                <Route path='/Year2' exact element = {<Year2/>} />
                <Route path='/Year3' exact element = {<Year3/>} />
                <Route path='/Year4' exact element = {<Year4/>} />
                <Route path='/Ai' exact element= {<Ai/>} />
                <Route path='/Me' exact element= {<Me/>} />
                <Route path='/Ce' exact element= {<Ce/>} />
                <Route path='/Ee' exact element= {<Ee/>} />
                <Route path='/Ec' exact element= {<Ec/>} />
                <Route path='/It' exact element= {<It/>} />
                <Route path='/Others' exact element= {<Others/>} />
                <Route path='/SelectBranchB' exact element= {<SelectBranchB/>} />
                <Route path='/Bcs' exact element= {<Bcs/>} />
                <Route path='/Bai' exact element= {<Bai/>} />
                <Route path='/Bme' exact element= {<Bme/>} />
                <Route path='/Bce' exact element= {<Bce/>} />
                <Route path='/Bee' exact element= {<Bee/>} />
                <Route path='/Bec' exact element= {<Bec/>} />
                <Route path='/Bit' exact element= {<Bit/>} />
                <Route path='/Bothers' exact element= {<Bothers/>} />
                <Route path='/SelectBranchP' exact element= {<SelectBranchP/>} />
                <Route path='/PYear2' exact element= {<PYear2/>} />
                <Route path='/Pcs' exact element= {<Pcs/>} />
                <Route path='/Pai' exact element= {<Pai/>} />
                <Route path='/Pme' exact element= {<Pme/>} />
                <Route path='/Pce' exact element= {<Pce/>} />
                <Route path='/Pee' exact element= {<Pee/>} />
                <Route path='/Pec' exact element= {<Pec/>} />
                <Route path='/Pit' exact element= {<Pit/>} />
                <Route path='/Pothers' exact element= {<Pothers/>} />
                <Route path='/TopContribuorsV' exact element= {<TopContribuorsV/>} />
                <Route path='/OnlineToolV' exact element= {<OnlineToolV/>} />
                <Route path='/SoftwareDownloadV' exact element= {<SoftwareDownloadV/>} />
                <Route path='/YoutubeUrl' exact element= {<YoutubeUrl/>} />
                <Route path='/CollegeReviewV' exact element= {<CollegeReviewV/>} />
                <Route path='/WebsiteUrlV' exact element= {<WebsiteUrlV/>} />
            </Routes>
      </Router>
    </div>
  );
}

